import { OrigenRservas } from "src/gql/schema"
import { Tarifa } from "src/gql/schema"

export const origenList = {
    telefono: "Teléfono",
    recepcion: "Recepción",
    email: "Email",
    expedia: "Expedia",
    booking: "Booking.com",
    tripadvisor: "TripAdvisor",
    trivago: "Trivago",
    despegar: "Despegar",
    bestday: "Bestday",
    checkfront: "Checkfront",
    priceline: "Priceline",
    kayak: "Kayak",
    hotels: "Hotels.com",
    hotwire: "Hotwire",
    otros: "Otro",
}

export const getKey = (value: string): string => {
    return value === "Teléfono"
        ? "Telefono"
        : value === "Recepción"
        ? "Recepcion"
        : Object.keys(OrigenRservas).find((key) => key === value) || "otros"
}

export const getParams = (params: any) => {
    return {
        fechaReserva: params?.fechaReserva || [new Date(), new Date()],
        tipoHabitacion: params?.tipoHabitacion?.nombre || "-",
        tipoHabitacionId: String(params?.tipoHabitacion.id) || "",
        codigoReserva: params?.codigoReserva || "",
        cantidadPersonasExtra: params?.cantidadPersonasExtra || 0,
        cantidadPersonas: params?.cantidadPersonas || 0,
        costoPersonaExtra: Number(params?.costoPersonaExtra) || 0,
        origenReserva: OrigenRservas[params?.origenReserva] || "",
        horaCheckIn: params?.horaCheckIn,
        horaCheckOut: params?.horaCheckOut,
        experiencias: params?.experiencias || [],
        reservaIdSaved: String(params?.reservaIdSaved),
        folioSaved: Number(params?.folioSaved),
        experienciasSaved: params?.experienciasSaved || [],
        nombreHuespedSaved: params?.nombreHuespedSaved,
        telefonoHuespedSaved: params?.telefonoHuespedSaved,
        emailHuespedSaved: params?.emailHuespedSaved,
        totalSaved: Number(params?.totalSaved),
        pagosSaved: params?.pagosSaved,
        comentarioSaved: String(params?.comentarioSaved),
        habitacionId: params?.habitacionId || null,
        tarifasSeleccionadas: (params?.tarifasSeleccionadas || []) as Tarifa[],
        tarifasAdicionalesSeleccionadas: (params?.tarifasAdicionalesSeleccionadas || []) as Tarifa[],
        descuentoId: params?.descuentoId || "",
        descuento: params?.descuento || 0,
    }
}

export const getDays = (dateI: Date | string, dateF: Date | string): number => {
    const datef = new Date(dateI)
    const datei = new Date(dateF)
    const time = datef.getTime() - datei.getTime()
    return Math.abs(time / (1000 * 60 * 60 * 24))
}
